export default{px:"S",py:"XS",radius:"S"};
